import { type BoxProps, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { type Theme } from "contexts/color-theme";
import React from "react";
import { Link } from "./link";

type Crumb = {
  title: string;
  href: string;
};

export type BreadcrumbsProps = {
  /** Use this setting to apply the primary text color for the links (if needed for a11y support). */
  hasPrimaryText?: boolean;
  theme?: Theme;
  crumbs: Crumb[];
} & BoxProps;

export function Breadcrumbs({ theme = "light", hasPrimaryText, crumbs, ...props }: BreadcrumbsProps) {
  return (
    <Breadcrumb
      separator="/"
      color={`brand.${hasPrimaryText ? "text" : "textSecondary"}.${theme}`}
      textStyle="caption1"
      {...props}
    >
      {crumbs.map((crumb, index) => (
        <BreadcrumbItem key={crumb.href}>
          <BreadcrumbLink as={Link} href={crumb.href} variant="breadcrumb">
            {index === 0 ? "← " : ""}
            {crumb.title}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}
